import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trans } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useUpdateCompany = options => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(body => organizationServices.updateCompany(body), {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.useGetUserKey]);
      showSuccess({
        message: <Trans i18nKey="changesSuccessfullySaved" components={{ b: <b /> }} />,
        type: 'toast'
      });
      options?.onSuccess?.();
    },
    ...options
  });
};
